










import Vue from 'vue';
import Component from 'vue-class-component';
import Photoroll from '@/components/photoroll.vue';

@Component({
  name: 'photo-gallery',
  components: {
      Photoroll
  },
})
export default class PhotosPage extends Vue {
}
